import { GetRequest } from "./HttpService";

export const getHomeInfo = async () => {
  const data = await GetRequest("/Common/get-home-info");
  return data;
};
